import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { useClients } from '../../hooks/useClients';
import { formatRut } from '../../utils/rutValidator';

export interface ClientSelectorProps {
  value: string | null;
  onChange: (clientId: string | null) => void;
  disabled?: boolean;
  placeholder?: string;
  emptyMessage?: string;
}

const ClientSelector: React.FC<ClientSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  placeholder = 'Seleccionar cliente',
  emptyMessage = 'No hay clientes registrados. Crea uno desde "Gestión Clientes".',
}) => {
  const { data, isLoading } = useClients({ active: true });

  const clients = data?.items ?? [];

  const handleValueChange = (selectedValue: string) => {
    if (selectedValue === '__none__') {
      onChange(null);
    } else {
      onChange(selectedValue);
    }
  };

  if (!isLoading && clients.length === 0) {
    return (
      <div className="flex h-10 w-full items-center rounded-md border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-500">
        {emptyMessage}
      </div>
    );
  }

  return (
    <Select
      value={value ?? '__none__'}
      onValueChange={handleValueChange}
      disabled={disabled || isLoading}
    >
      <SelectTrigger>
        <SelectValue placeholder={isLoading ? 'Cargando...' : placeholder} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="__none__">{placeholder}</SelectItem>
        {clients.map((client) => (
          <SelectItem key={client.clientId} value={client.clientId}>
            {client.name} ({formatRut(client.rut)})
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default ClientSelector;
